import styled, { css } from "styled-components/native";
import { CheckBoxMargin } from "screens/question/themeB/types/check-box/variables";

import {
  flexRow,
  flexStart,
  pickStyle as _,
  pickThemeKey as theme,
} from "utils";
import {
  ContainerWidth,
  ContainerFullWidth,
} from "screens/question/themeB/types/text-input/variables";
import {
  Checkbox as BaseCheckbox,
  CheckMarkImage as BaseCharkMarkImage,
  Label as BaseLabel,
} from "screens/question/themeB/types/check-box/styled";

export const Container = styled.TouchableOpacity`
  align-self: center;
  flex-direction: ${flexRow()};
  justify-content: ${flexStart()};
  align-items: center;
  margin-bottom: ${_(CheckBoxMargin) || "30"}px;
  ${props =>
    props.$fullWidth
      ? css`
          width: ${_(ContainerFullWidth) || "100%"};
        `
      : css`
          width: ${_(ContainerWidth) || "100%"};
        `}
`;

export const Checkbox = styled(BaseCheckbox)`
  background-color: ${props =>
    props.$isSelected ? theme("selected_option")(props) : "transparent"};
  border: 2px solid ${theme("option_text")};
  height: ${theme("consent_icon_size")}
  width: ${theme("consent_icon_size")}
`;

export const CheckMarkImage = styled(BaseCharkMarkImage)`
  height: ${theme("consent_icon_size")}
  width: ${theme("consent_icon_size")}
`;

export const Label = styled(BaseLabel)`
  color: ${theme("option_text")};
  font-size: ${theme("consent_text_size")}px;
  font-family: ${theme("consent_text_style")};
`;
